import { cn } from '@/lib/cn';
import { MonoLabel } from './MonoLabel';

interface StripePlaceholderProps {
  /** What belongs here once real artwork exists: "pack art", "cover art". */
  caption?: string;
  className?: string;
}

/** Diagonal-stripe stand-in for every image until real artwork lands. Size it
 * from the outside (aspect ratio, width, height). */
export function StripePlaceholder({ caption, className }: StripePlaceholderProps) {
  return (
    <div className={cn('flex items-end bg-stripes p-3', className)}>
      {caption && <MonoLabel className="text-[9px] tracking-[0.1em]">{caption}</MonoLabel>}
    </div>
  );
}
